<template>
  <div class="pagination-container">
    <el-button size="medium" @click="handlePre">上一页</el-button>
    <el-button size="medium" @click="handleNext">下一页</el-button>
  </div>
</template>

<script>

export default {
  name: 'BasePagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
  },
  methods: {
    handlePre() {
      if(this.page === 1) return;
      this.$emit('update:page', this.page - 1);
      this.$emit('pagination');
    },
    handleNext() {
      this.$emit('update:page', this.page + 1);
      this.$emit('pagination');
    }
  }
}
</script>

<style scoped>
.pagination-container {
  padding: 32px 16px;
  text-align: center;
}
</style>
